// src/data/servicesData.js

export const servicesData = [
  {
  slug: "diagnosztika",
  path: "/szolgaltatasok/diagnosztika",

  seo: {
    title: "Fogászati diagnosztika és megelőzés Szolnok – pontos vizsgálat",
    description:
      "Modern fogászati diagnosztika és dentálhigiénés kezelések Szolnokon.",
    canonical: "https://fogorvosszolnok.hu/szolgaltatasok/diagnosztika",
  },

  hero: {
    title: "Diagnosztika és megelőzés",
    subtitle:
      "Modern vizsgálatokkal időben felismerjük a problémákat – a tartósan egészséges mosolyért.",
    image: "/images/services/1bg.webp",
  },

  card: {
    title: "Diagnosztika és megelőzés",
    image: "/images/services/1.webp",
    alt: "Fogászati diagnosztika Szolnokon",
    content:
      "Modern eszközeinkkel pontos képet kapunk fogaid állapotáról. A rendszeres szűrések és denálhigiénés kezelések segítenek időben felismerni és megelőzni a komolyabb problémákat.",
  },

  section: {
    title: "Miért fontos a rendszeres fogászati vizsgálat?",
    paragraphs: [
      "A száj egészsége alapvetően meghatározza közérzetünket és életminőségünket. Szolnoki fogászatunkon kiemelt figyelmet fordítunk arra, hogy a problémákat időben felismerjük.",
      "A rendszeres diagnosztikai vizsgálatokkal megelőzhető a fogszuvasodás, az ínygyulladás és a komolyabb beavatkozások szükségessége.",
      "Korszerű diagnosztikai eszközök – rendelőnkben digitális röntgen és modern diagnosztikai technológiák állnak rendelkezésre, melyek gyors és pontos képet adnak a fogaid, ínyed és állkapcsod állapotáról.",
      "Dentálhigiénés kezelések – a megelőzés kulcsa a professzionális szájhigiénia. A rendszeres kezelések csökkentik a fogínybetegségek kockázatát és hozzájárulnak a hosszú távú fogmegőrzéshez.",
      "Szolnoki pácienseinknek ajánlott évente legalább kétszer részt venni fogászati kontrollon.",
    ],
  },

    prices: [
  {
    category: "Diagnosztika árlista",
    items: [
      { name: "Konzultáció", price: "12.000 Ft" },
      {
        name: "Konzultáció és panoráma röntgen",
        price: "18.000 Ft",
      },
      {
        name: "Góckutatás és panoráma röntgen",
        price: "18.000 Ft",
      },
      { name: "Kismama szűrés", price: "10.000 Ft" },
      { name: "OP-felvétel (panoráma röntgen)", price: "10.000 Ft" },
      { name: "Kis röntgen", price: "5.000 Ft" },
      { name: "3D CT felvétel (kicsi)", price: "23.000 Ft" },
      { name: "3D CT felvétel (nagy)", price: "30.000 Ft" },
      {
        name: "Sürgősségi felár (48 órán belüli ellátás)",
        price: "12.000 Ft",
      },
    ],
  },
  {
    category: "Dentálhigiénés kezelések árlista",
    items: [
      { name: "Fogkő eltávolítás", price: "25.000 Ft" },
      {
        name: "Fogkő eltávolítás és homokfúvás",
        price: "32.000 Ft",
      },
      {
        name: "Komplex szájhigiénés csomag (fogkő, homokfúvás, szájápolási tanácsadás)",
        price: "36.000 Ft",
      },
      {
        name: "Philips ZOOM fogfehérítés (rendelői)",
        price: "150.000 Ft",
      },
      {
        name: "Philips ZOOM fogfehérítés (otthoni + lenyomat + sín)",
        price: "75.000 Ft",
      },
      { name: "Barázdazárás", price: "10.000 Ft" },
      {
        name: "Iontoforézis (állcsontonként)",
        price: "8.000 Ft",
      },
      {
        name: "Belső fogfehérítés (alkalmanként)",
        price: "15.000 Ft",
      },
    ],
  },
],

  },

{
  slug: "fogmegtarto",
  path: "/szolgaltatasok/fogmegtarto",

  seo: {
    title:
      "Fogmegtartó kezelések Szolnokon – tömés, gyökérkezelés, inlay",
    description:
      "Fogmegtartó kezelések Szolnokon: esztétikus tömések, inlay, onlay és fájdalommentes gyökérkezelés a természetes fogak megőrzéséért.",
    canonical: "https://fogorvosszolnok.hu/szolgaltatasok/fogmegtarto",
  },

  hero: {
    title: "Fogmegtartó kezelések",
    subtitle:
      "Korszerű eljárásokkal segítünk megőrizni fogaid egészségét – a természetes mosolyért.",
    image: "/images/services/2bg.webp",
  },

  card: {
    title: "Fogmegtartó kezelések",
    image: "/images/services/2.webp",
    alt: "Fogmegtartó kezelések Szolnokon",
    content:
      "Célunk, hogy saját fogaidat a lehető legtovább megőrizzük. Korszerű tömések, esztétikus helyreállítások, gyökérkezelések segítenek megőrizni fogaid egészségét.",
  },

  section: {
    title: "Cél: saját fogaid megőrzése",
    paragraphs: [
      "Fogászatunk alapfilozófiája, hogy a lehető legtovább megőrizzük a természetes fogakat. Ehhez modern konzerváló eljárásokat alkalmazunk, amelyek hosszú távon biztosítják a fogak egészségét.",
      "Esztétikus tömések – A régi amalgám tömések helyett korszerű, fogszínű kompozit töméseket használunk, melyek tökéletesen illeszkednek a természetes fogszínhez, és esztétikus megjelenést biztosítanak.",
      "Inlay és onlay megoldások – Komolyabb szuvasodás esetén betétekkel (inlay, onlay) állítjuk helyre a fogat. Ezek tartósabbak a hagyományos töméseknél, és nagyobb stabilitást biztosítanak.",
      "Gyökérkezelés – a fájdalommentes megoldás – Ha a szuvasodás eléri a fogbél állományát, gyökérkezeléssel mentjük meg a fogat. Korszerű érzéstelenítési technikáinknak köszönhetően a kezelés teljesen fájdalommentes.",
      "Szolnoki rendelőnkben célunk, hogy minden fogat megőrizzünk, ameddig csak lehetséges.",
    ],
  },

 prices: [
  {
    category: "Konzerváló fogászat árlista",
    items: [
      { name: "Kompozit tömés (1 felszín)", price: "30.000 Ft" },
      { name: "Kompozit tömés (2 felszín)", price: "35.000 Ft" },
      { name: "Kompozit tömés (3 vagy több felszín)", price: "40.000 Ft" },
      { name: "Élpótlás", price: "45.000 Ft" },
      {
        name: "Üvegszállal megerősített tömés (3 vagy több felszín)",
        price: "50.000 Ft",
      },
      {
        name: "Alap behelyezése (mély szuvasodás esetén)",
        price: "5.000 Ft",
      },
      { name: "Fognyaki tömés", price: "22.000 Ft" },
      {
        name: "Csonkfelépítés és gyári csap",
        price: "40.000 Ft",
      },
      { name: "Csonkfelépítés", price: "32.000 Ft" },
      {
        name: "Direkt esztétikus héj",
        price: "57.000 Ft",
      },
      { name: "Mozgó fogak sínezése", price: "5.000 Ft" },
    ],
  },

  {
    category: "Gyökérkezelés árlista",
    items: [
      {
        name: "Gyökércsatorna előkészítés – frontfog",
        price: "26.000 Ft",
      },
      {
        name: "Gyökércsatorna előkészítés – premoláris fog",
        price: "28.000 Ft",
      },
      {
        name: "Gyökércsatorna előkészítés – moláris fog",
        price: "30.000 Ft",
      },
      {
        name: "Gyógyszeres lezárás – frontfog",
        price: "5.000 Ft",
      },
      {
        name: "Gyógyszeres lezárás – premoláris fog",
        price: "5.000 Ft",
      },
      {
        name: "Gyógyszeres lezárás – moláris fog",
        price: "5.000 Ft",
      },
      {
        name: "Gyökértömés – frontfog (1 csatorna)",
        price: "23.000 Ft",
      },
      {
        name: "Gyökértömés – frontfog (2 csatorna)",
        price: "28.000 Ft",
      },
      {
        name: "Gyökértömés – premoláris fog (1 csatorna)",
        price: "23.000 Ft",
      },
      {
        name: "Gyökértömés – premoláris fog (2 csatorna)",
        price: "28.000 Ft",
      },
      {
        name: "Gyökértömés – moláris fog (3 csatorna)",
        price: "34.000 Ft",
      },
      {
        name: "Gyökértömés – moláris fog (4 csatorna)",
        price: "40.000 Ft",
      },
      {
        name: "Régi gyökértömés eltávolítása – frontfog",
        price: "10.000 Ft",
      },
      {
        name: "Régi gyökértömés eltávolítása – premoláris fog",
        price: "15.000 Ft",
      },
      {
        name: "Régi gyökértömés eltávolítása – moláris fog",
        price: "35.000 Ft",
      },
      { name: "Fedőtömés", price: "20.000 Ft" },
      {
        name: "Nehézségi felár",
        price: "15.000 Ft",
      },
    ],
  },
],

},

{
  slug: "fogpotalas",
  path: "/szolgaltatasok/fogpotalas",

  seo: {
    title: "Fogpótlás és implantáció Szolnokon – természetes mosoly",
    description:
      "Hiányzó fogaid pótlása koronával, híddal vagy implantátummal Szolnokon. Stabil, esztétikus és hosszú távú megoldások.",
    canonical: "https://fogorvosszolnok.hu/szolgaltatasok/fogpotalas",
  },

  hero: {
    title: "Fogpótlás és implantáció",
    subtitle:
      "Természetes hatású koronák, hidak és implantátumok a magabiztos mosolyért.",
    image: "/images/services/3bg.webp",
  },

  card: {
    title: "Fogpótlás és implantáció",
    image: "/images/services/3.webp",
    alt: "Fogpótlás és implantáció Szolnokon",
    content:
      "Hiányzó fogaid pótlására több megoldást kínálunk, a koronáktól az implantátumokig. Tartós, esztétikus megoldásokkal állítjuk helyre mosolyod funkcióját és megjelenését.",
  },

  section: {
    title: "Miért fontos a hiányzó fogak pótlása?",
    paragraphs: [
      "A foghiány nemcsak esztétikai probléma: hosszú távon rontja a rágóképességet, és állkapocs- valamint ízületi problémákhoz vezethet. Szolnoki fogászatunkon többféle korszerű megoldást kínálunk.",
      "Fogpótlási lehetőségek – Koronák és hidak, kivehető fogpótlások és kombinált megoldások is elérhetőek, melyek tartós és esztétikus megoldást nyújtanak a hiányzó fogak pótlására.",
      "Implantáció – a legmodernebb megoldás – Az implantátum a csontba kerül beültetésre, stabil alapot biztosítva a koronának vagy hídnak. Ezáltal visszanyerhető a teljes rágófunkció és a természetes megjelenés.",
      "Szolnoki fogászatunkon a fogpótlás mindig személyre szabott kezelési terv alapján történik.",
    ],
  },

prices: [
  {
    category: "Fogpótlás árlista",
    items: [
      { name: "Korona (porcelán)", price: "85.000 Ft" },
      { name: "Korona (cirkónium)", price: "112.000 Ft" },

      { name: "Ideiglenes korona (rendelői)", price: "5.000 Ft" },
      { name: "Ideiglenes korona (fogtechnikai)", price: "20.000 Ft" },

      { name: "Híd (porcelán leplezésű)", price: "85.000 Ft" },
      { name: "Híd (cirkónium)", price: "112.000 Ft" },

      { name: "Ideiglenes híd (rendelői)", price: "5.000 Ft" },
      { name: "Ideiglenes híd (fogtechnikai)", price: "20.000 Ft" },

      {
        name: "Protetika – rögzített pótlás lenyomat",
        price: "15.000 Ft",
      },
      { name: "Antagonista lenyomat", price: "10.000 Ft" },

      { name: "Csonkfelépítés", price: "32.000 Ft" },
      {
        name: "Csonkfelépítés és gyári csap",
        price: "40.000 Ft",
      },

      { name: "Porcelánhéj", price: "138.000 Ft" },

      {
        name: "Rögzített fogmű eltávolítása (foganként)",
        price: "5.000 Ft",
      },

      { name: "Protetika – alábélelés", price: "40.000 Ft" },

      { name: "Teljes protézis", price: "250.000 Ft" },
      {
        name: "Teljes protézis prémium fogakkal",
        price: "310.000 Ft",
      },
      {
        name: "Teljes protézis fémhálóval",
        price: "270.000 Ft",
      },
      {
        name: "Teljes protézis fémhálóval és prémium fogakkal",
        price: "340.000 Ft",
      },

      {
        name: "Rejtett elhorgonyzású kivehető fogpótlás",
        price: "385.000 Ft",
      },
      {
        name: "Kapcsos elhorgonyzású kivehető fogpótlás",
        price: "280.000 Ft",
      },

      { name: "Dezorientációs sín", price: "45.000 Ft" },
      { name: "Éjszakai harapásemelő sín", price: "45.000 Ft" },

      {
        name: "Fogmű ragasztás (cementtel, foganként)",
        price: "2.000 Ft",
      },
      {
        name: "Fogmű ragasztás (fogszínű ragasztóval)",
        price: "6.000 Ft",
      },
    ],
  },

  {
    category: "Implantáció árlista",
    items: [
      {
        name: "Konzultáció + 3D CT felvétel + árajánlat",
        price: "30.000 Ft",
      },

      { name: "SGS implantátum", price: "175.000 Ft" },
      { name: "Multi-unit fej (SGS)", price: "65.000 Ft" },

      { name: "Nobel implantátum", price: "260.000 Ft" },
      { name: "Multi-unit fej (Nobel)", price: "110.000 Ft" },

      { name: "Műtéti steril szett", price: "10.000 Ft" },
    ],
  },
],


},

 {
  slug: "szajsebeszet",
  path: "/szolgaltatasok/szajsebeszet",

  seo: {
    title:
      "Szájsebészet Szolnokon – bölcsességfog eltávolítás, fogműtétek",
    description:
      "Szájsebészeti beavatkozások Szolnokon: bölcsességfog eltávolítás, gyökér- és ciszta műtétek fájdalommentesen.",
    canonical: "https://fogorvosszolnok.hu/szolgaltatasok/szajsebeszet",
  },

  hero: {
    title: "Szájsebészet",
    subtitle:
      "Bölcsességfog eltávolítás és egyéb szájsebészeti beavatkozások biztonságosan, fájdalommentesen.",
    image: "/images/services/4bg.webp",
  },

  card: {
    title: "Szájsebészet",
    image: "/images/services/4.webp",
    alt: "Szájsebészet Szolnokon",
    content:
      "Rendelőnkben a szükséges szájsebészeti beavatkozásokat – például fogeltávolítást – nyugodt környezetben, korszerű érzéstelenítéssel végezzük, a mielőbbi gyógyulás érdekében.",
  },

  section: {
    title: "Mikor van szükség szájsebészeti beavatkozásra?",
    paragraphs: [
      "Vannak olyan helyzetek, amikor a hagyományos fogászati módszerek nem elegendők, és szájsebészeti beavatkozásra van szükség. Ilyen például a bölcsességfog eltávolítása, ciszták kezelése vagy a súlyosan károsodott fogak eltávolítása.",
      "Biztonság és fájdalommentesség – Tapasztalt szájsebészeink modern érzéstelenítési eljárásokat alkalmaznak, így a műtétek teljesen fájdalommentesek, gyors gyógyulással és minimális kellemetlenséggel.",
      "Bölcsességfog eltávolítás, foggyökér- és ciszta műtétek, valamint szájüregi elváltozások kezelése is elérhető rendelőnkben.",
      "Szolnoki fogászatunkon a szájsebészeti kezelések biztonságosak, gyorsak és kíméletesek.",
    ],
  },

prices: [
  {
    category: "Szájsebészet árlista",
    items: [
      { name: "Extractio (frontfog)", price: "20.000 Ft" },
      { name: "Extractio (frontfog, gyökér)", price: "25.000 Ft" },

      { name: "Extractio (premoláris fog)", price: "22.000 Ft" },
      {
        name: "Extractio (premoláris fog, gyökér)",
        price: "25.000 Ft",
      },

      { name: "Extractio (moláris fog)", price: "24.000 Ft" },
      {
        name: "Extractio (moláris fog, gyökér)",
        price: "28.000 Ft",
      },

      {
        name: "Extractio bölcsességfog (egyszerű)",
        price: "35.000 Ft",
      },

      { name: "Extractio tejfog", price: "15.000 Ft" },

      { name: "Lézer használat", price: "10.000 Ft" },
    ],
  },
],


},
{
  slug: "fogszabalyozas",
  path: "/szolgaltatasok/fogszabalyozas",

  seo: {
    title:
      "Fogszabályozás Szolnokon – láthatatlan és felnőtt fogszabályozó",
    description:
      "Gyermek- és felnőtt fogszabályozás Szolnokon modern, esztétikus készülékekkel.",
    canonical: "https://fogorvosszolnok.hu/szolgaltatasok/fogszabalyozas",
  },

  hero: {
    title: "Fogszabályozás",
    subtitle:
      "Modern fogszabályozási megoldások minden korosztálynak – láthatatlan és esztétikus készülékekkel.",
    image: "/images/services/5bg.webp",
  },

  card: {
    title: "Fogszabályozás",
    image: "/images/services/5.webp",
    alt: "Fogszabályozás Szolnokon",
    content:
      "Gyermek- és felnőtt fogszabályozást egyaránt végzünk. Láthatatlan és hagyományos megoldásokkal segítünk a rendezett fogsor és a harmonikus mosoly megteremtésében.",
  },

  section: {
    title: "Miért érdemes fogszabályozásba kezdeni?",
    paragraphs: [
      "A szabályos fogsor nemcsak esztétikai kérdés, hanem a rágás és a beszéd szempontjából is fontos. Szolnoki rendelőnkben korszerű fogszabályozási eljárásokat kínálunk minden korosztály számára.",
      "Gyermek fogszabályozás – A növekedésben lévő állkapocs irányítható, ezért a korai kezelés kiemelten fontos.",
      "Felnőtt fogszabályozás – Bármely életkorban lehetséges, modern és esztétikus készülékekkel.",
      "Láthatatlan és esztétikus megoldások – Fém, kerámia és átlátszó sínes fogszabályozók is elérhetőek, melyek diszkrétek és hatékonyak.",
      "Személyre szabott kezelési terv – Minden fogszabályozás egyéni diagnosztikán alapul, modern digitális eszközökkel.",
      "Szolnoki pácienseink számára a fogszabályozás a magabiztos mosoly és az egészséges harapás záloga.",
    ],
  },

  prices: [
  {
    category: "Diagnosztika és konzultáció",
    items: [
      {
        name: "Szaktanácsadás + OPT + teleröntgen",
        price: "25.000 Ft",
      },
      {
        name: "Lenyomatvétel vagy digitális scan (állcsontonként)",
        price: "12.000 Ft",
      },
    ],
  },

  {
    category: "Rögzített fogszabályozó készülékek",
    items: [
      {
        name: "Rögzített készülék – 3M fém",
        price: "210.000 Ft",
      },
      {
        name: "Rögzített készülék – Synergy fém",
        price: "210.000 Ft",
      },
      {
        name: "Rögzített készülék – Iconix (arany)",
        price: "250.000 Ft",
      },
      {
        name: "Rögzített készülék – porcelán (3M)",
        price: "310.000 Ft",
      },
      {
        name: "Rögzített készülék ragasztása (típustól függetlenül)",
        price: "20.000 Ft",
      },
      {
        name: "Lingual / palatinális készülék",
        price: "90.000 Ft",
      },
      {
        name: "Hyrax készülék",
        price: "120.000 Ft",
      },
      {
        name: "Rögzített készülék eltávolítása",
        price: "25.000 Ft",
      },
      {
        name: "Harapásemelés rögzített készülékhez",
        price: "5.000 Ft",
      },
      {
        name: "Leesett bracket pótlása (30 napon túl)",
        price: "15.000 Ft",
      },
      {
        name: "Második nagyőrlőre tubus ragasztás",
        price: "10.000 Ft",
      },
    ],
  },

  {
    category: "Rögzített készülékek ellenőrzése",
    items: [
      {
        name: "Rögzített készülék ellenőrzés (1 állcsont)",
        price: "15.000 Ft",
      },
      {
        name: "Rögzített készülék ellenőrzés (2 állcsont)",
        price: "25.000 Ft",
      },
    ],
  },

  {
    category: "Kivehető fogszabályozó készülékek",
    items: [
      {
        name: "Funkciós készülékek (Hansa / Frankel / Klammt)",
        price: "120.000 Ft",
      },
      {
        name: "Orthoplus készülékek (trainer)",
        price: "65.000 Ft",
      },
      {
        name: "Multi TB trainer rögzített készülékhez",
        price: "40.000 Ft",
      },
      {
        name: "Aktív lemez (állcsontonként)",
        price: "95.000 Ft",
      },
      {
        name: "Aktív lemez + funkciós kiegészítő elemek",
        price: "115.000 Ft",
      },
      {
        name: "Retenciós készülék rögzített kezelés után",
        price: "45.000 Ft",
      },
      {
        name: "Éjszakai harapásemelő sín",
        price: "45.000 Ft",
      },
    ],
  },

  {
    category: "Kivehető készülékek ellenőrzése",
    items: [
      {
        name: "Kivehető készülék ellenőrzés (1 állcsont / retenciós 2 állcsont)",
        price: "10.000 Ft",
      },
      {
        name: "Kivehető készülék ellenőrzés bimax készülékeknél",
        price: "12.000 Ft",
      },
    ],
  },
],

},


];
